import api from './api';

export interface FeatureRequestData {
  title: string;
  description: string;
  business_value?: string;
  page_url?: string;
  screenshot_url?: string;
  uploaded_images?: string[];
  additional_info?: Record<string, any>;
}

export interface FeatureRequestResponse {
  id: number;
  /** Help Center request page for the new ticket. */
  url: string;
  title: string;
  status: string;
  created_at?: string;
  message: string;
}

export interface FeatureRequestConfig {
  enabled: boolean;
}

const featureRequestsService = {
  /**
   * Submit a feature request to Zendesk.
   *
   * Tagged `feature-request` rather than filed as a distinct ticket type.
   * Priority is no longer collected — agents triage urgency.
   */
  async submitFeatureRequest(data: FeatureRequestData): Promise<FeatureRequestResponse> {
    const response = await api.post('/feature-requests/submit', data);
    return response.data;
  },

  /**
   * Get feature request configuration
   */
  async getConfig(): Promise<FeatureRequestConfig> {
    const response = await api.get('/feature-requests/config');
    return response.data;
  }
};

export default featureRequestsService;
